import { Avatar, Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import DesignSystem from '../../designSystem';

export function EntityRow({
  avatar,
  avatarSrc,
  avatarLetter,
  title,
  meta,
  trailing,
  onClick,
  dense = false,
}: {
  avatar?: ReactNode;
  avatarSrc?: string;
  avatarLetter?: string;
  title: string;
  meta?: string;
  trailing?: ReactNode;
  onClick?: () => void;
  dense?: boolean;
}) {
  return (
    <Box
      component="div"
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        width: '100%',
        border: 0,
        background: 'transparent',
        textAlign: 'left',
        font: 'inherit',
        color: 'inherit',
        cursor: onClick ? 'pointer' : 'default',
        px: dense ? 1.25 : 1.5,
        py: dense ? 1.05 : 1.2,
        borderRadius: DesignSystem.borderRadius.lg,
        transition: `background-color ${DesignSystem.motion.duration} ${DesignSystem.motion.easing}`,
        '&:hover': onClick ? { backgroundColor: DesignSystem.colors.hover } : undefined,
      }}
    >
      {avatar ?? (
        <Avatar
          src={avatarSrc}
          sx={{
            width: dense ? 36 : 40,
            height: dense ? 36 : 40,
            bgcolor: DesignSystem.colors.surfaceElevated,
            color: DesignSystem.colors.textPrimary,
            fontWeight: 700,
            fontSize: dense ? 14 : 15,
            flexShrink: 0,
          }}
        >
          {avatarLetter || title.charAt(0)}
        </Avatar>
      )}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: 15,
            fontWeight: 700,
            lineHeight: 1.25,
            letterSpacing: '-0.015em',
            color: DesignSystem.colors.textPrimary,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </Typography>
        {meta && (
          <Typography
            sx={{
              fontSize: 13,
              color: DesignSystem.colors.textSecondary,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              mt: 0.15,
            }}
          >
            {meta}
          </Typography>
        )}
      </Box>
      {trailing && <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>{trailing}</Box>}
    </Box>
  );
}

export default EntityRow;
